import { Link } from '@tanstack/react-router';

import { Alert, AlertDescription } from '@nesso/ui/primitives/alert';
import { Button } from '@nesso/ui/primitives/button';

import presentIllustration from '@/shared/assets/present-illustration.svg';
import { AuthCard } from '@/shared/ui/auth/auth-card';

type Props = {
    signUpData: string | undefined;
};

export function ReferralPage({ signUpData }: Props) {
    return (
        <div className="flex flex-1 items-start justify-center px-4">
            <AuthCard size="medium" className="mt-31 items-center gap-8 pt-8 pb-10">
                <div>
                    <img src={presentIllustration} alt="" width={73} height={95} />
                </div>
                <div className="flex w-full flex-col gap-8 sm:gap-6">
                    <h1 className="text-2xl sm:text-3xl font-bold md:text-4xl">
                        Unlock a free month
                    </h1>
                    <p className="text-base">
                        Nesso Notes is the tool for busy therapists: fast, compliant notes so your
                        backlog—and the guilt—are gone.
                    </p>
                    <Alert variant="accent" className="p-4 pl-2">
                        <AlertDescription className="text-base! font-medium! text-foreground!">
                            When you upgrade to a paid plan, you&rsquo;ll get a free month — and so
                            will the person who referred you.
                        </AlertDescription>
                    </Alert>
                </div>
                <Button asChild className="w-full">
                    <Link to="/signup" search={{ signUpData }}>
                        Start Your Free Trial
                    </Link>
                </Button>
            </AuthCard>
        </div>
    );
}
